import { Navigate, useLocation } from "react-router-dom";
import { keepSharedFilterParams } from "@/pages/analytics/analyticsRoutes";

/**
 * An analytics redirect (ANL-E04-S03 AC5): it replaces the history entry, so Back skips it, and
 * keeps only the filters every analytics screen shares.
 */
const AnalyticsRedirect = ({ to }: { to: string }) => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: to, search: keepSharedFilterParams(search) }} replace />;
};

export default AnalyticsRedirect;
